<form [formGroup]="componentForm">
	<div class="row mb-3" [attr.data-test-id]="'familyPatientInsuranceCopyInsuranceFormGroup'">
		<div class="offset-sm-4 offset-md-3 col-md-8 col-lg-9">
			<ejs-checkbox formControlName="copyInsurance" label="Copy Insurance"></ejs-checkbox>
		</div>
	</div>
	<div class="row mb-3">
		<label class="col-md-4 col-lg-3 col-form-label">Relation to Insured</label>
		<div class="col-md-8 col-lg-9">
			<pms-constant-dropdown [constantList]="policyHolderRelationshipOptions"
							  formControlName="relationshipToInsured">
			</pms-constant-dropdown>
		</div>
	</div>
</form>
